import {DateFormat} from "../date_format"
import {createPdf} from '../pdf/utils'

export default class BaseReportPDFGenerator {
    init(store, generalStore, productSettingsValidator, reportRightsValidator) {
        this.onGenerateBreaker = {needBreak: false};
        this.store = store;
        this.generalStore = generalStore;
        this.productSettingsValidator = productSettingsValidator;
        this.reportRightsValidator = reportRightsValidator;

        return this;
    }

    interruptGeneration() {
        this.onGenerateBreaker.needBreak = true;
    }

    _getCreatePDFDefinitionStrategy() {
        return null;
    }

    calculateTotalNumberOfPages(params) {
        return 0;
    }

    generatePDF() {
        var newBreaker = {
            needBreak: false
        };
        this.onGenerateBreaker = newBreaker;

        var pdfPrintParameters = this.store.getPrintParametersForSave();
        var reportParams = this.store.getReportParams();

        var rows = this.store.getConvertedData();

        var pdfConfig = {
            pdfPrintParameters: pdfPrintParameters,
            pdfData: {
                tableData: rows
            },
            reportParams: reportParams,
            dateFormat: new DateFormat(window.SystemSettings.dateFormat)
        };

        var s = this;
        return new Promise(
            function(onComplete) {
                onComplete(pdfConfig);
            }
        ).then(
            function(pdfConfig) {
                return new Promise(function(onComplete, onError) {
                    defer(_.bind(onComplete, this, pdfConfig));
                });
            }
        ).then(
            function(pdfConfig) {
                if (newBreaker["needBreak"]) {
                    return Promise.reject(new Error("abort"));
                }
                return s._generatePDF(pdfConfig, newBreaker);
            }
        );
    }

    _generatePDF(config, breaker) {
        var paramFormattingStrategy = this._getParametersFormattingStrategy(config);

        return this.docDefinitionCreator
                   .createDocDefinition(config, paramFormattingStrategy, this.store)
                   .then(
                       function(ddObject) {
                           var doc = createPdf(ddObject["docDefinition"]);
                           var currentFileName = paramFormattingStrategy.formatChartPDFFileName(config.reportParams);

                           return new Promise(function(onComplete, onError) {
                               try {
                                   doc._createDoc(
                                       {
                                           tableLayouts: ddObject["tableLayouts"]
                                       },
                                       function(result, pages) {
                                           if (breaker.needBreak) {
                                               return onError(new Error("abort"));
                                           }

                                           onComplete({
                                               encodedPDF: result,
                                               fileName: currentFileName,
                                               pageCount: pages.length
                                           })
                                       }
                                   );

                               }
                               catch (e) {
                                   onError(e);
                               }
                           });
                       }
                   );
    }
}


// WEBPACK FOOTER //
// ./web/js/reports/BaseReportPDFGenerator.js